/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {TargetingHelper} from '../targeting-helper';

import template from './segment-summary.component.html';

@Component({
  standalone: false,
  selector: 'adn-targeting-segment-summary',
  template
})
export class SegmentSummaryComponent implements OnChanges {
  @Input() targets: any;

  data: any[] = [];
  isComplex = false;
  showOnly = 2;
  quantity = 2;

  ngOnChanges(): void {
    const targets = this.targets || {};
    this.isComplex = TargetingHelper.isComplexSegments(targets);
    this.data = targets;
    this.quantity = this.showOnly;
  }

  switchUp(): void {
    if (this.quantity === this.showOnly) {
      this.quantity = this.data.length;
      return;
    }
    this.quantity = this.showOnly;
  }
}
